import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import GenericTable from "../../components/0. Tablas/PerfilesTable";
import MaestrasView from "../../components/1.1 maestras/Maestra";
import LoadingOverlay from "../../components/0. Utilidades/LoadingOverlay";
import { FaWhatsapp } from "react-icons/fa";

const MaestraPage = () => {
  const { rut } = useParams();
  const [selectedMaestra, setSelectedMaestra] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const handlePageChange = useCallback((newPage) => {
    setCurrentPageIndex(newPage);
  }, []);

  const handlePageSizeChange = useCallback((newSize) => {
    setCurrentPageSize(newSize);
  }, []);

  const location = useLocation();

  // 1) Map route -> backend Maestra.tipo values
  const tipoByPath = {
    "/todas": "Todas",
    "/maestras": "Maestra",
    "/maestras_externas": "Maestra Externa",
    "/alumna": "Alumna",
    "/especial": "Especial",
  };

  // 2) Normalize path (remove trailing slash)
  const normalizedPath = location.pathname.replace(/\/$/, "");

  // 3) Pick tipo (default to "Maestra" if unknown)
  let tipo;

  if (normalizedPath === "/todas") {
    // Send all tipos except "Todas"
    tipo = Object.values(tipoByPath)
      .filter((t) => t !== "Todas")
      .join(",");
  } else {
    tipo = tipoByPath[normalizedPath] || "Maestra";
  }

  useEffect(() => {
    if (rut) {
      setLoadingDetail(true);
      fetch(`${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${rut}/`)
        .then((response) => response.json())
        .then((data) => {
          setSelectedMaestra(data);
          setShowModal(true); // <== ADD THIS LINE
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching maestra:", error);
          setLoading(false);
        })
        .finally(() => {
          setLoadingDetail(false);
        });
    } else {
      setLoading(false);
    }
  }, [rut]);

  const handleMaestraSelect = (maestra) => {
    setLoadingDetail(true);
    setShowModal(false);
    setSelectedMaestra(null);

    fetch(
  `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestra.rut}/`,
)
      .then((res) => res.json())
      .then((data) => {
        setSelectedMaestra(data);
        setShowModal(true); // Only now show the modal
      })
      .catch((err) => console.error("Error:", err))
      .finally(() => {
        setLoadingDetail(false);
      });
  };

  const columns = [
  {
    Header: "Maestra",
    accessor: "nombre", // still needed for sorting/search
    Cell: ({ row }) => {
      const item = row.original;

      const groups = Array.isArray(item?.grupos_whatsapp)
        ? item.grupos_whatsapp
        : [];

      const groupNames = groups
        .map((g) => g?.nombre)
        .filter(Boolean);

      const relation = (item?.e_relacion || "").toLowerCase();

      return (
        <div className="maestra-row">
          
          {/* Vertical relation bar */}
          <div
            className={`maestra-relation-bar ${
              relation === "problema"
                ? "maestra-relation-bar-problema"
                : "maestra-relation-bar-ok"
            }`}
          />

          {/* Main content */}
          <div className="maestra-content">

            {/* Top line */}
            <div className="maestra-main-line">

              <span className="maestra-name">
                {item?.nombre ?? ""}
              </span>

              {item?.sec === true && (
                <span className="badge bg-info">SEC</span>
              )}

              {groupNames.length > 0 && (
                <span className="maestra-whatsapp-wrapper">
                  <FaWhatsapp className="maestra-whatsapp-icon" />

                  <span className="maestra-whatsapp-tooltip">
                    {groupNames.map((name) => (
                      <span key={name}>{name}</span>
                    ))}
                  </span>
                </span>
              )}
            </div>

            {/* Secondary info */}
            <div className="maestra-secondary">
              <span>{item?.comuna}</span>
              <span className="separator">|</span>
              <span>{item?.oficio}</span>
            </div>

            

          </div>
        </div>
      );
    },
  },
];


  if (loading) return <LoadingOverlay />;

  const titleLabel =
    normalizedPath === "/todas" ? "Todas" : tipo;

  return (
    <>
      {/* Show overlay during initial page load or detail fetch */}
      {(loading || loadingDetail) && <LoadingOverlay />}

      <div className="maestra-page capsule">
        <GenericTable
          apiUrl={`${process.env.REACT_APP_BASE_API}api/perfiles/tabla/maestras/?tipo=${encodeURIComponent(tipo)}`}
          columns={columns}
          onRowClick={handleMaestraSelect}
          category="maestras"
          title={titleLabel}   
          initialPageIndex={currentPageIndex}
          onPageChange={handlePageChange}
          pageSize={currentPageSize}
          onPageSizeChange={handlePageSizeChange}
        />

        {/* Modal shows only when we have data */}
        {showModal && selectedMaestra && (
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="xl"
            backdrop="static"
            dialogClassName="modal-100w"
          >
            <Modal.Body className="maestra-detail-modal position-relative">
              <button
                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-3"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
              <MaestrasView maestra={selectedMaestra} />
            </Modal.Body>
          </Modal>
        )}
      </div>
    </>
  );
};

export default MaestraPage;
